import { ROUTES } from "@config";
import { ExpandMore } from "@mui/icons-material";
import {
  Alert,
  Checkbox,
  Collapse,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { fillRouteWithSlugs } from "@utils";
import { Link, useParams } from "react-router-dom";
import { ROUTE_SLUGS } from "src/config/navigation/routes";

type DependencyWarningProps = {
  dependentDocs: [string, string][];
  setAgreement: (agreement: boolean) => void;
  agreement: boolean;
  seeMore: boolean;
  setSeeMore: (seeMore: boolean) => void;
};

export const DependencyWarning = ({
  dependentDocs,
  setAgreement,
  agreement,
  seeMore,
  setSeeMore,
}: DependencyWarningProps) => {
  const { deviceId = "", orgId = "" } = useParams();

  const handleChange = () => {
    setSeeMore(!seeMore);
  };

  return (
    <>
      {dependentDocs.length > 0 && (
        <div className="flex flex-col gap-2">
          <Alert severity="warning">
            <Typography variant="body1" fontWeight={600}>
              Dependency Update Warning
            </Typography>
            <div>
              Because the documents listed below use data from this document,
              you should regenerate and re-approve them.
              <ul className="p-0">
                <Collapse in={seeMore} collapsedSize={35}>
                  {dependentDocs.map(([template, title]) => (
                    <li key={template} className="list-inside">
                      <Link
                        to={fillRouteWithSlugs(ROUTES.QMS_OPEN_DOC, {
                          [ROUTE_SLUGS.ORG_ID]: orgId,
                          [ROUTE_SLUGS.DEVICE_ID]: deviceId,
                          [ROUTE_SLUGS.TEMPLATE_KEY]: template,
                        })}
                      >
                        {title}
                      </Link>
                    </li>
                  ))}
                </Collapse>
                {dependentDocs.length > 2 && (
                  <div
                    className="flex items-center cursor-pointer mt-3 hover:underline"
                    onClick={handleChange}
                  >
                    <span>Show more</span>
                    <ExpandMore
                      className={` ${seeMore ? "rotate-180" : ""} transition-all`}
                    />
                  </div>
                )}
              </ul>
            </div>
          </Alert>
          <div>
            <FormGroup>
              <FormControlLabel
                className="m-0"
                control={
                  <Checkbox
                    id="agreement"
                    size="small"
                    checked={agreement}
                    onChange={() => setAgreement(!agreement)}
                  />
                }
                label="Confirm the dependency update warning above."
              />
            </FormGroup>
          </div>
        </div>
      )}
    </>
  );
};

export default DependencyWarning;
